import {getFaInfo, getOwnerInfo, getTrusteeInfo, getCorporateInfo, getPiInfo} from './ESigner'
import getSecondaryPiInfo from './ESigner/getSecondaryPiInfo';

/**
 * / Summary: Set ESigner Info
 * / clientData: Info coming back from the ClientAccount call when a user clicks refresh
 * / formState: ESign component formState
 */

const getESignerInfo = async (formState, clientData = null) => {

  let newForm = {...formState};
  const {retrieveAccount} = newForm.pages;

  // if we have new client account info from refresh use that otherwise use previous response from formState
  const clientDataObj = clientData || retrieveAccount.clientData;

  let signers = [];
  signers = signers.concat(getFaInfo(newForm));
  signers = signers.concat(getOwnerInfo(newForm, clientDataObj));
  signers = signers.concat(getPiInfo(newForm));
  signers = signers.concat(getSecondaryPiInfo(newForm));
  signers = signers.concat(getTrusteeInfo(newForm, clientDataObj));
  signers = signers.concat(getCorporateInfo(newForm, clientDataObj));

  return signers.filter(s => s !== null);
}

export default getESignerInfo;




// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ESign/Helpers/getESignData.js